<template>
  <div :class="$style.numbers">
    <div
      :class="[$style.numbers__column, $style.value]"
      :key="index"
      v-for="(item, index) in items"
    >
      <p :class="$style.value__text">{{ item.text }}</p>
      <NumberTicker
        :class="$style.value__number"
        :value="item.value"
        :duration="400"
        mode="asc"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import NumberTicker from '@/components/atoms/NumberTicker.vue'

type Item = {
  text: string
  value: number
}

export type SummaryNumbers = {
  qrMatches: number
  onlineMatches: number
  messages: number
}

export default defineComponent({
  name: 'MatchSummaryNumbers',
  components: {
    NumberTicker,
  },
  props: {
    qrMatches: {
      type: Number,
      required: true,
    },
    onlineMatches: {
      type: Number,
      required: true,
    },
    messages: {
      type: Number,
      required: true,
    },
  },
  computed: {
    items(): Item[] {
      return [
        {
          text: '総マッチ数',
          value: this.qrMatches + this.onlineMatches,
        },
        {
          text: 'QRコードからのマッチ数',
          value: this.qrMatches,
        },
        {
          text: 'オンラインマッチ数',
          value: this.onlineMatches,
        },
        {
          text: 'メッセージ数',
          value: this.messages,
        },
      ]
    },
  },
})
</script>

<style lang="scss" module>
.numbers {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto;

  &__column {
    align-self: center;

    &:nth-child(n + 2) {
      padding-left: 24px;
      border-left: 1px solid $color-border-low-emphasis;
    }
  }
}

.value {
  &__number {
    color: $color-text-and-object-accent-primary;
    font-size: 36px;
    font-weight: bold;
    line-height: 52px;
  }

  &__text {
    color: $color-text-and-object-high-emphasis;
    font-size: 14px;
  }
}
</style>
